import React, {useContext} from 'react';
import DatePicker from 'react-date-picker';
import TimePicker from 'react-time-picker';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Context } from '../../store';
import InputField from '../InputField'
import PdfPreviewInvoice from '../PdfPreview/PdfPreviewInvoice';
import { globalValidator } from "../../utils";
import SelectField from '../SelectField';
import {
	SET_ERROR,
	SET_COMMON_LOADING
} from '../../store/types';
import { addDischargePatientWard, addServiceWardPatient } from '../../api/organization';

import './index.css';

const DischargeModal = (prop) => {
	const [state, dispatch] = useContext(Context);
    const { id, patientDetails, setPatientDetails, setModalVisible, loader,showPreviewModal,setShowSubModal } = prop;
	const [payment, setPaymentData] = React.useState([]);
    const [pdfPrevieModal,setPdfPreviewModal] = React.useState(false)
    const [ignored, forceUpdate] = React.useReducer(x => x + 1, 0);
    const [serviceDetails, setServicesDetails] = React.useState({
		serviceDate: '',
        serviceName: '',
        serviceAmount: '',
        // serviceAddedBy: JSON.parse(localStorage.getItem('subuser'))._id,
		addedByApi : false,
    })
    const [dischargeData, setDischargeData] = React.useState({
        dischargeDate: '',
        otherAmount: '',
        tax: '',
        discount: '',
        paymentMode: 'CASH',
        summary: ''
        // insurance : false
    });
    const handlechargesInput = (e) => {
        const reg = /^(0|[1-9]\d*)$/
        if (reg.test(e.target.value) || e.target.value === '') {
            setServicesDetails((serviceDetails) => ({ ...serviceDetails, [e.target.name]: e.target.value }))
        } else {
            toast.error('Please Input Only Numbers')
        }
    }
    const handleDischargeInputs = (e) => {
        const reg = /^(0|[1-9]\d*)$/
        if (reg.test(e.target.value) || e.target.value === '') {
            setDischargeData((dischargeDate) => ({ ...dischargeDate, [e.target.name]: e.target.value }));
        } else {
            toast.error('Please Input Only Numbers')
        }
    }
    const handleDeleteService = (id) => {
        const data = patientDetails?.services;
        data.splice(id, 1);
        setPatientDetails({ ...patientDetails, services: data })
        setPaymentData(data);
        forceUpdate()
    }
    const handleSubmit= () => {
        const keys = [
            { name: "dischargeDate", title: "Discharge Date", validateKey: "required" },
        ];
        let valid = globalValidator(dischargeData, keys);
        if (valid === true) {
            loader(true)
            const disData = {
                ...dischargeData,
                totalPayableAmount: JSON.stringify(payableAmount()),
                dischargeDate: dischargeData.dischargeDate,
                totalAmountService: JSON.stringify(totalAmount()),
            }
            addServiceWardPatient(id, payment).then((res) => {
                addDischargePatientWard(id, disData).then((resp) => {
                    loader(false)
                    toast.success("Patient is successfully discharged!")
                    dispatch({
                        type: SET_ERROR,
                        payload: "Patient is successfully discharged!"
                    });
                    setPatientDetails(resp.data);
                    setModalVisible(false);
                    if (showPreviewModal) {
                        setShowSubModal(true);
                    } else {
                        document.body.style.overflowY = 'auto';
                    }
                }).catch((err) => {
                    toast.error(err)
                    dispatch({
                        type: SET_ERROR,
                        payload: err?.response?.data?.error
                    });
                    loader(false)
                })
            }).catch((err) => {
                loader(false)
            })
        } else {
            toast.error(valid)
        }
    }
    const handlePreview = () => {
        setPdfPreviewModal(!pdfPrevieModal);
    }
    const handleServiceSubmit = () => {
        const keys = [
            { name: "serviceDate", title: "Date", validateKey: "required" },
            { name: "serviceName", title: "Service Name", validateKey: "required" },
            { name: "serviceAmount", title: "Charges", validateKey: "required" },
        ];
        let valid = globalValidator(serviceDetails, keys);

        if (valid === true) {
            setPaymentData([...payment, serviceDetails]);
            setPatientDetails({ ...patientDetails, services: [...patientDetails.services, serviceDetails] })

            setServicesDetails({
                serviceDate: '',
                time: '',
                serviceName: '',
                serviceAmount: '',
                // serviceAddedBy: JSON.parse(localStorage.getItem('doctor'))._id,
                addedByApi: false,
            })
        } else {
            toast.error(valid)
        }
    }
    const payableAmount = () => {
        let total = totalAmount();
        return total + (dischargeData.otherAmount ? parseInt(dischargeData.otherAmount) : 0) + (total * (dischargeData.tax && parseInt(dischargeData.tax)) / 100) - (dischargeData.discount && parseInt(dischargeData.discount))
    }
    const totalAmount = () => {
        // let total = 0;
        // patientDetails?.services?.map((data) => {
        //     total = total + data.serviceAmount ? data.serviceAmount : '0'
        // })
        // return total

        let total = []
        let sum = 0;
        patientDetails?.services?.map((item) => {
            item?.serviceAmount && total.push(parseInt(item?.serviceAmount))
            })

        for (let i = 0; i < total.length; i++) {
            sum += total[i];
        }
        return sum;
    }
    return (
        <>
            <div className="modal fade call-modal show" id="video_call" aria-modal="true" style={{ display: 'block', background: 'rgb(80 88 80 / 10%)', backdropFilter: 'blur(2px)' }}>
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '70%' }} role="document">
                    <div className="modal-content" style={{ maxHeight: "700px", overflowY: "scroll" }}>
                        <div className="col-md-12 service-discharge-form" style={{ padding: '30px' }}>
                            {!patientDetails.dischargeByDoctor && <div className="col-md-12 p-2 warning-card text-center mb-2">
                                Please contact doctor
                            </div>}
                            <div style={{ display: "flex" }}>
                                <p style={{ fontSize: "18px", fontWeight: "500" }}>Service Details</p>
                                {/* <i onClick={()=>handleAddPaymentData()} class="fa fa-plus todo-add-icon" aria-hidden="true"></i> */}
                            </div>
                            <div className="row pt-3">
                                <div className="col-md-2 no-padding form-group">
                                    <label>Service</label>
                                    <InputField value={serviceDetails.serviceName} onChange={e => setServicesDetails((serviceDetails) => ({ ...serviceDetails, serviceName: e.target.value }))} />
                                </div>
                                <div className="col-md-3 no-padding form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label>Date</label>
                                    <DatePicker minDate={new Date()} showTimeSelect value={serviceDetails.serviceDate} className="ipdwardDatePicker" selected={serviceDetails.serviceDate} onChange={date => setServicesDetails((serviceDetails) => ({ ...serviceDetails, serviceDate: date }))} />
                                </div>
                                <div className="col-md-3 no-padding form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label>Time</label>
                                    <TimePicker
                                        openClockOnFocus
                                        onChange={time => {
                                            if(time == null){
                                                return false
                                            }
                                            if (serviceDetails.serviceDate) {
                                                serviceDetails.serviceDate.setHours(time.split(':')[0]);
                                                serviceDetails.serviceDate.setMinutes(time.split(':')[1]);
                                            }
                                            else if (time) {
                                                new Date().setHours(time.split(':')[0]);
                                                new Date().setMinutes(time.split(':')[1]);
                                            }
                                            setServicesDetails((serviceDetails) => ({ ...serviceDetails, serviceDate: serviceDetails.serviceDate }))
                                        }}
                                        value={serviceDetails.serviceDate}
                                        format="hh:mm:ss a"
                                        className="admission-details-timepicker"
                                    />
                                </div>
                                <div className="col-md-2 no-padding form-group">
                                    <label>Charges</label>
                                    <InputField name="serviceAmount" value={serviceDetails.serviceAmount} onChange={handlechargesInput} />
                                </div>
                                <div className="col-md-2 no-padding form-group">
                                    <button style={{ marginLeft: 'auto', marginTop: '1.75rem' }} className="doctor-active-btn doctor-w-20" onClick={handleServiceSubmit}>Submit </button>
                                </div>
                            </div>
                            <div style={{ height: "200px", overflowY: "auto" }}>
                                <table className="table table-bordered ">
                                    <thead className="thead-light to-do-thead" style={{ position: "sticky", top: -1 }}>
                                        <tr>
                                            <th>No</th>
                                            <th>Date & Time</th>
                                            <th>Service</th>
                                            <th>Charges</th>
                                            <th>Added By</th>
                                            <th style={{ minWidth: "30px" }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ overflow: "scroll" }} key={payment}>
                                        {patientDetails?.services && patientDetails?.services.map((data, i) => {
                                            return (
                                                <tr key={"item-" + i} className="to-do-table-row">
                                                    <td>{i + 1}</td>
                                                    <td style={{ flexDirection: 'row' }}>
                                                        {moment(data.date).format('Do MMM, YYYY')}{" "}{data.serviceDate && moment(data.serviceDate).format('hh:mm a')}
                                                    </td>
                                                    <td style={{overflowWrap: 'anywhere'}}>
                                                        {data.serviceName}
                                                    </td>
                                                    <td style={{overflowWrap: 'anywhere'}}>
                                                        {data.serviceAmount}
                                                    </td>
                                                    <td style={{overflowWrap: 'anywhere'}}>
                                                        {data.addedBy}
                                                    </td>
                                                    <td style={{ textAlign: 'center', padding: '10px 15px' }}>
                                                        {
                                                            (data.addedByApi && data.addedByApi) === false ?
                                                                <i style={{ margin: "auto", padding: "inherit", cursor: "pointer" }} class="fa fa-times" aria-hidden="true" onClick={() => handleDeleteService(i)}></i>
                                                                : null
                                                        }
                                                    </td>
                                                </tr>
                                            );
                                        })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-md-10 row mt-4">
                                <div className="col-md-7 no-padding form-group" style={{ textAlign: 'left' }}>
                                    <label style={{ fontWeight: '600' }}>Discharge Date:</label>
                                </div>
                                <div className="col-md-4 no-padding form-group row" style={{ flexDirection: 'column' }}>
                                    <DatePicker minDate={new Date()} showTimeSelect value={dischargeData.dischargeDate} className="ipdwardDatePicker" selected={dischargeData.dischargeDate} onChange={date => setDischargeData((dischargeData) => ({ ...dischargeData, dischargeDate: date }))} />
                                </div>
                            </div>
                            <div className="col-md-10 row">
                                <div className="col-md-3 no-padding form-group">
                                </div>
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-4 no-padding form-group row" style={{ flexDirection: 'column' }}>
                                    <TimePicker
                                        clearIcon={false}
                                        openClockOnFocus
                                        onChange={time => {
                                            if(time == null){
                                                return false
                                            }
                                            if (dischargeData.dischargeDate) {
                                                dischargeData.dischargeDate.setHours(time.split(':')[0]);
                                                dischargeData.dischargeDate.setMinutes(time.split(':')[1]);
                                            }
                                            else if (time) {
                                                new Date().setHours(time.split(':')[0]);
                                                new Date().setMinutes(time.split(':')[1]);
                                            }
                                        }}
                                        value={dischargeData.dischargeDate}
                                        format="hh:mm:ss a"
                                        className="admission-details-timepicker"
                                    />
                                </div>
                            </div>
                            <div className="col-md-10 row">
                                <div className="col-md-3 no-padding form-group">
                                    <label style={{ fontWeight: '600' }} className="ml-auto">Amount : </label>
                                </div>
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-4 no-padding form-group row" style={{ flexDirection: 'column' }}>
                                    <InputField value={totalAmount()} readOnly={true}/>
                                </div>
                            </div>
                            <div className="col-md-10 row">
                                <div className="col-md-3 no-padding form-group">
                                    <label style={{ fontWeight: '600' }} className="ml-auto">Other Amount : </label>
                                </div>
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-4 no-padding form-group row" style={{ flexDirection: 'column' }}>
                                    <InputField name="otherAmount" value={dischargeData.otherAmount} onChange={handleDischargeInputs} />
                                </div>
                            </div>
                            <div className="col-md-10 row">
                                <div className="col-md-3 no-padding form-group">
                                    <label style={{ fontWeight: '600' }} className="ml-auto">Tax (%) : </label>
                                </div>
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-4 no-padding form-group row" style={{ flexDirection: 'column' }}>
                                    <InputField name="tax" value={dischargeData.tax} onChange={handleDischargeInputs} />
                                </div>
                            </div>
                            <div className="col-md-10 row">
                                <div className="col-md-3 no-padding form-group">
                                    <label style={{ fontWeight: '600' }} className="ml-auto">Discount : </label>
                                </div>
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-4 no-padding form-group row" style={{ flexDirection: 'column' }}>
                                    <InputField name="discount" value={dischargeData.discount} onChange={handleDischargeInputs} />
                                </div>
                            </div>
                            <div className="col-md-10 row">
                                <div className="col-md-3 no-padding form-group">
                                    <label style={{ fontWeight: '600' }} className="ml-auto">Payment Mode : </label>
                                </div>
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-4 no-padding form-group row" style={{ flexDirection: 'column' }}>
                                    <SelectField value={dischargeData.paymentMode} onChange={e => setDischargeData((dischargeData) => ({ ...dischargeData, paymentMode: e.target.value }))} options={[{ id: 1, label: 'CASH', value: 'CASH' }, { id: 2, label: 'ONLINE', value: 'ONLINE' }]} />
                                </div>
                            </div>
                            <div className="col-md-10 row">
                                <div className="col-md-4 no-padding form-group">
                                    <label style={{ fontWeight: '600' }} className="ml-auto">Payable Amount : </label>
                                </div>
                                <div className="col-md-3">
                                </div>
                                <div className="col-md-4 no-padding form-group row" style={{ flexDirection: 'column' }}>
                                    {parseFloat(payableAmount()).toFixed(2)}
                                </div>
                            </div>
                            <div className="col-md-10 row">
                                <div className="col-md-4 no-padding form-group">
                                    <label style={{ fontWeight: '600' }} className="ml-auto">Summary : </label>
                                </div>
                                <div className="col-md-1">
                                </div>
                                <div className="col-md-6 no-padding form-group row" style={{ flexDirection: 'column' }}>
                                    <textarea name="summary" value={dischargeData.summary} onChange={(e) => setDischargeData((dischargeDate) => ({ ...dischargeDate, summary: e.target.value }))} rows={3} cols={50} style={{ lineHeight: "24px", padding: "10px", width: "100%", borderRadius: "5px", border: "2px solid #979797" }} />
                                </div>
                            </div>
                        </div>
                        <div className="row ml-auto mb-5 mr-5">
                            <button disabled= {!patientDetails.dischargeByDoctor} style={{ marginLeft: 'auto', marginTop: '1.75rem',  }} className={`doctor-active-btn doctor-w-20 ml-auto ${!patientDetails.dischargeByDoctor ? "button-disabled" : ''}`} onClick={handleSubmit}>Submit </button>
                            <button disabled={patientDetails?.services?.length === 0 ? true : false} style={{ marginLeft: 'auto', marginTop: '1.75rem' }} className="doctor-active-btn doctor-w-20 ml-auto" onClick={handlePreview}>Preview </button>
                            <button style={{ marginLeft: 'auto', marginTop: '1.75rem' }} className="doctor-active-btn doctor-w-20 ml-auto" onClick={() => {
                                setModalVisible(false);
                                document.body.style.overflowY = 'auto';
                            }}>Cancel </button>
                        </div>
                    </div>
                </div>
                {pdfPrevieModal && <div className="modal fade call-modal show pdf-preview-modal" id="video_call" aria-modal="true" style={{ display: 'block', background: 'rgb(80 88 80 / 10%)', backdropFilter: 'blur(2px)' }}>
                    <i style={{ fontSize: "28px", right: "139px", margin: "18px", position: "absolute", color: "white" }} class="fa fa-times" aria-hidden="true" onClick={(e) => setPdfPreviewModal(false)}></i>
                    <PdfPreviewInvoice patientDetails={patientDetails} dischargeData={dischargeData} payment={patientDetails?.services} payableAmount={payableAmount()} totalAmount={totalAmount()} />
                </div>}
            </div>
        </>
    )
}
export default DischargeModal